export const sanitizeZipcode = (value) => {
  if (value == null) return value;
  return value.toString()
    .replace(/[\u200B-\u200D\uFEFF\u00AD]/g, '')
    .trim();
};
